import { applyCartFragments } from '../utils/cart-fragments.js'

document.addEventListener('alpine:init', () => {
	window.Alpine.data('productPopup', () => ({
		productPopupOpen: false,
		productPopupTitle: '',
		productPopupConfig: [],
		productPopupOptions: [],
		productPopupOptionId: null,
		productPopupForm: null,

		closeProductPopup() {
			this.productPopupOpen = false
			this.productPopupTitle = ''
			this.productPopupConfig = []
		},

		openProductPopup(event) {
			this.productPopupOpen = true
			this.productPopupTitle = event.detail.product?.name
			this.productPopupConfig = event.detail.product?.config || []
			this.productPopupOptions = this.productPopupConfig.options || []
			this.productPopupOptionId = this.productPopupOptions[1]?.id
		},

		submitProductPopup() {
			const formData = new FormData()
			formData.append(
				'quantity',
				this.$refs.productPopupForm.querySelector("[name='quantity']").value,
			)
			formData.append('product_id', this.productPopupOptionId)

			fetch('/?wc-ajax=add_to_cart', {
				method: 'POST',
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.error) {
						if (data.product_url) {
							window.location = data.product_url
						}

						return
					}

					applyCartFragments(data.fragments)

					this.$nextTick(() => this.$dispatch('cart-updated'))
				})
				.catch(() => null)

			this.closeProductPopup()
		},
	}))
})
